export default class InvalidWorkspaceError extends Error {
  constructor() {
    super('Workspace inválido. Verifique o campo e tente novamente.');
    this.name = 'InvalidWorkspaceError';
  }
}
